import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

export function Title(props) {
  return (
    <h3 className={style.title}>
      {props.text}
    </h3>
  );
}

Title.propTypes = {
  /**
   * text is used display the heading of the tab
   */
  text: PropTypes.string.isRequired,
  /**
   * style to recive from out of the component
   */
  className: PropTypes.string,
};

Title.defaultProps = {
  text: '',
};
